// Write your code here.

import './index.css'

const ThumbnailItem = props => {
  const {imageDetails, onClickThumbnail, isActive} = props

  const {id, thumbnailUrl, thumbnailAltText} = imageDetails

  const onClickButton = () => {
    onClickThumbnail(id)
  }

  const thumbnailClass = isActive ? 'active-thumb' : 'thumb'

  return (
    <li className="thumbnail-item">
      <button className="button" type="button" onClick={onClickButton}>
        <img
          src={thumbnailUrl}
          className={thumbnailClass}
          alt={thumbnailAltText}
        />
      </button>
    </li>
  )
}

export default ThumbnailItem
